import React from 'react';
import { Review } from '../types';

export type ModalState =
    | {
          isVisible: false;
          review: null;
      }
    | {
          isVisible: true;
          review: Review;
      };

export type ModalAction =
    | {
          type: 'open';
          payload: Review;
      }
    | {
          type: 'close';
      };

const reducer: React.Reducer<ModalState, ModalAction> = (
    state: ModalState,
    action: ModalAction,
) => {
    switch (action.type) {
        case 'close':
            return { isVisible: false, review: null };
        case 'open':
            return { isVisible: true, review: action.payload };
        default:
            throw new Error('unsupported action');
    }
};

export default reducer;
